import React from "react";

export default function OffboardWorkerModal({
  open,
  titleId,
  workerName,
  endDate,
  onEndDateChange,
  offboardIdType,
  onOffboardIdTypeChange,
  canUseAttuid,
  disableDtvOption,
  note,
  onNoteChange,
  dateError,
  error,
  submitting,
  canSubmit,
  onCancel,
  onSubmit,
}) {
  if (!open) return null;

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true" aria-labelledby={titleId}>
      <div className="modal ap-modal">
        <h2 id={titleId}>Off Board Worker</h2>
        <p>Are you sure you want to offboard this worker?</p>

        <label>Worker Name</label>
        <input type="text" value={workerName || ""} readOnly />

        <label>End Date</label>
        <input
          type="date"
          value={endDate}
          onChange={(e) => onEndDateChange(e.target.value)}
          min={new Date().toISOString().split("T")[0]}
          disabled={submitting}
        />
        {dateError && <div className="err">{dateError}</div>}

        <label>Offboard By</label>
        <div style={{ display: "flex", gap: 16, alignItems: "center", flexWrap: "wrap", marginBottom: 8 }}>
          <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: (submitting || disableDtvOption) ? "not-allowed" : "pointer" }}>
            <input
              type="checkbox"
              checked={offboardIdType === "DTVID"}
              onChange={() => onOffboardIdTypeChange("DTVID")}
              disabled={submitting || disableDtvOption}
            />
            <span>DTVID/ATTUID</span>
          </label>

          <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: (!canUseAttuid || submitting) ? "not-allowed" : "pointer" }}>
            <input
              type="checkbox"
              checked={offboardIdType === "ATTUID"}
              onChange={() => onOffboardIdTypeChange("ATTUID")}
              disabled={!canUseAttuid || submitting}
              title={!canUseAttuid ? "ATTUID not available for this worker." : ""}
            />
            <span>ATTUID</span>
          </label>
        </div>

        <label>Notes (optional)</label>
        <textarea
          value={note}
          onChange={(e) => onNoteChange(e.target.value)}
          rows={3}
          placeholder="Add any context for the offboard request"
          disabled={submitting}
        />

        {error && <div className="err">{error}</div>}

        

        <div className="modal-buttons" style={{ marginTop: 12 }}>
          <button onClick={onCancel} disabled={submitting}>
            Cancel
          </button>
          <button className="primary" onClick={onSubmit} disabled={submitting || !canSubmit}>
            {submitting ? "Submitting..." : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
}
